export enum QaAddendumConstants {
  SET_FLAG_DETAIL = 'qaAddendum/SET_FLAG_DETAIL',
  SET_ADDENDUM_TEXT = 'qaAddendum/SET_ADDENDUM_TEXT',
  SET_SELECTED_FLAG_ID = 'qaAddendum/SET_SELECTED_FLAG_ID',
  FETCH_QA_FLAG_DETAIL = 'qaAddendum/FETCH_QA_FLAG_DETAIL',
  FETCH_CHART_SUMMARY = 'qaAddendum/FETCH_CHART_SUMMARY',
  SET_CHART_SUMMARY = 'qaAddendum/SET_CHART_SUMMARY',
  SUBMIT_QA_FLAG_ADDENDUM = 'qaAddendum/SUBMIT_QA_FLAG_ADDENDUM',
  SET_SUBMITTING = 'qaAddendum/SET_SUBMITTING',
  SET_REASSIGN_ASSIGNEE = 'qaAddendum/SET_REASSIGN_ASSIGNEE',
  SET_REASSIGN_REASON = 'qaAddendum/SET_REASSIGN_REASON',
  RESET_REASSIGN = 'qaAddendum/RESET_REASSIGN',
  RESET_DRAFT_INPUTS = 'qaAddendum/RESET_DRAFT_INPUTS',
  REASSIGN_QA_FLAG = 'qaAddendum/REASSIGN_QA_FLAG',
  RESET_STATE = 'qaAddendum/RESET_STATE',
}
export const OTHER_OBSERVER = 'Other/Observer'
export const ALL_CREW_MEMBERS_ID = 0
